import React from "react";
import { cn } from "@/lib/utils";

/**
 * Circa orbital mark — warm ring with a proximity node.
 */
const CircaMark = ({ className, title = "Circa", decorative = false }) => (
  <svg
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn("shrink-0", className)}
    role={decorative ? "presentation" : "img"}
    aria-hidden={decorative ? true : undefined}
    aria-label={decorative ? undefined : title}
  >
    {!decorative && <title>{title}</title>}
    <circle
      cx="24"
      cy="24"
      r="18"
      stroke="currentColor"
      strokeWidth="2.5"
      opacity="0.35"
    />
    <circle
      cx="24"
      cy="24"
      r="12"
      stroke="currentColor"
      strokeWidth="2.5"
    />
    <circle cx="24" cy="24" r="3.5" fill="currentColor" />
    <circle cx="36" cy="14" r="3" fill="currentColor" />
    <path
      d="M26.2 21.8C29.2 18.5 32.5 15.8 36 14"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      opacity="0.85"
    />
  </svg>
);

export default CircaMark;
